<template>
  <div>
    <h5 class="mb-4">환경일일점검</h5>
    <search-nav size="mobile" align="justify-end" @handleSearch="handleSearch">
      <search-nav-item-keyword class="w-full" size="mobile" label="키워드" v-model="nav.keyword"></search-nav-item-keyword>
    </search-nav>
    <div class="flex mb-4" style="justify-content: flex-end;">
      <vs-button class="w-1/2 mr-1" type="border" color="secondary" @click="handleClickApprovalLine">{{$t('button.결재선 지정')}}</vs-button>
      <vs-button class="w-1/2 ml-1 " color="secondary" @click="handleClickRegister">신규작성</vs-button>
    </div>
    <div style="margin:0 -1.2rem;">
      <vs-table
        style="border:1px solid #cdcdcd; border-radius: 0;"
        stripe
        ref="table"
        :sst="true"
        :max-items="table.perPage"
        :data="table.list"
        noDataText="'대상기간' 을 선택하거나, 키워드 검색을 진행하여 주세요."
        @selected="handleItemClickDetail">

        <template slot="thead">
          <vs-th style="min-width:130px;"><span class="w-full text-center">No.</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">제목</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">작성자</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">실시일</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">결재상태</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">첨부파일</span></vs-th>

        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="text-center">{{ tr.post_id }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).title }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).writer }}</vs-td>

            <vs-td class="text-center">{{ getPreview(tr).s_check_date }} ~ {{ getPreview(tr).e_check_date }}</vs-td>
            <vs-td class="text-center">{{ tr.document_status.name }}</vs-td>
            <vs-td class="text-center">
              <a download target="_blank" :href="img.path" v-for="(img, index) in getProjectAttachList(tr)" :key="index" @click.stop>
                <vs-icon icon-pack="feather" icon="icon-file" />
              </a>
            </vs-td>
          </vs-tr>



        </template>
      </vs-table>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(lastPage) ? lastPage : 1"
            v-model="currentPage" @change="handleTableChangePage"></k-pagination>
        </div>
      </div>
    </div>

    <popup-approval-process
      :show-popup="showApprovalLinePopup"
      @closePopup="handleCloseApprovalPopup"/>

  </div>
</template>

<script>
import SearchNav from '@/views/components/nav/SearchNav'
import SearchNavItemDate from '@/views/components/nav/SearchNavItemDate'
import SearchNavItemKeyword from '@/views/components/nav/SearchNavItemKeyword'
import SearchNavItemSelect from '@/views/components/nav/SearchNavItemSelect'
import KPagination from '@/views/components/kPagination/kPagination'
import PopupApprovalProcess from '@/views/content/approval/PopupApprovalProcess'
export default {
  name: 'MobileStateDailyCheckList',
  components: {
    PopupApprovalProcess,
    KPagination,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNavItemDate,
    SearchNav
  },
  computed: {
    rootPath () {
      const paths = this.$route.path.split('/')
      return `/${paths[1]}/${paths[2]}/${paths[3]}`
    }
  },
  data () {
    return {
      // 검색 네비게이션
      nav: {
        date: ['', ''],
        keyword: '',
        type:'',
        typeList:[]
      },

      currentPage: 1,
      lastPage: 1,
      table: {
        list: [],
        perPage: 7,
        keyword: ''
      },
      showApprovalLinePopup: false
    }
  },
  created () {
    this.loadPostList()
  },

  methods: {

    async loadPostList () {
      const projectId = this.$route.params.proj_id
      const boardSlug = 'environment_check_daily'
      const boardId = 28
      const page = this.currentPage
      const perPage = this.table.perPage
      const keyword = []
      if (this.nav.keyword) keyword.push(this.nav.keyword)

      await this.$store.dispatch('approval/LOAD_POST_ALL', {projectId, boardSlug, page, perPage, keyword})

      this.table.list = this.$store.state.approval.list
      const listInfo = this.$store.state.approval.postListInfo
      this.currentPage = listInfo.current_page
      this.lastPage = listInfo.last_page
    },

    handleSearch () {
      this.loadPostList()
    },

    getPreview (data) {
      if (data.post.preview) {
        const preview = JSON.parse(data.post.preview)
        return preview
      }
    },
    handleTableChangePage (page) {
      this.currentPage = page
      this.loadPostList()
    },
    handleItemClickDetail (data) {
      this.$router.push(`${data.post_id}/daily-check-update`)
    },
    handleClickRegister () {
      this.$router.push('daily-check-create')
    },

    handleClickApprovalLine () {
      this.showApprovalLinePopup = true
    },
    handleCloseApprovalPopup () {
      this.showApprovalLinePopup = false
    },

    getProjectAttachList (data) {
      if (data.post.preview) {

        const preview = JSON.parse(data.post.preview)

        try {
          const attachList = preview.attach_file

          return attachList
        } catch (e) {
          return []
        }

      }

      return ''
    }
  }
}
</script>

<style scoped>

</style>
